/**
 * @module app.bdc.list.sectorCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function SectorCtrl($rootScope, $location, $log, Notification, clientService) {
        var self = {};

        self.sector = null;
        self.sectors = [];

        self.hasClients = false;
        self.isDownloading = false;

        /**
         * Add a sector to the list
         */
        self.addDepartement = function addDepartement() {
            if (self.sector && (self.sector.length === 2 || self.sector.length === 5) && /^[0-9]*$/.test(self.sector)) {
                for (var i = 0; i < self.sectors.length; i++) {
                    if (self.sectors[i] === self.sector) {
                        Notification.error('Le département ou le code postal est déjà présent dans la liste');
                        return;
                    }
                }

                self.sectors.push(self.sector);
                clientService.addSector(self.sector);
                self.sector = null;
                return;
            }

            Notification.error("La valeur n'est pas un département ou un code postal");
        };

        /**
         * download the clients according to the sectors list
         */
        self.downloadClients = function downloadClients() {
            if (!self.sectors.length) {
                return;
            }

            self.isDownloading = true;

            clientService
                .downloadClients(self.sectors)
                .then(function() {
                    Notification.success('Les clients ont été téléchargés');
                    self.hasClients = true;
                })
                .catch(function(err) {
                    $log.error(err);
                    Notification.error(err.message);
                })
                .finally(function() {
                    self.isDownloading = false;
                });
        };

        /**
         * Clear clients indexedDB table
         */
        self.clearClients = function clearClients() {
            clientService
                .clearLocalClients()
                .then(function() {
                    self.hasClients = false;
                    self.sectors = [];
                    clientService.clearSectors();
                    Notification.success('La base a été vidée');
                })
                .catch(function(err) {
                    $log.error(err);
                    Notification.error(err.message);
                });
        };

        self.isOnline = function isOnline() {
            return $rootScope.online;
        };

        function _init() {
            self.sectors = clientService.getSectors();
            self.hasClients = self.sectors.length;
        }

        _init();

        return self;
    }

    SectorCtrl.$inject = ['$rootScope', '$location', '$log', 'Notification', 'clientService'];

    angular.module('app.bdc.list.sectorCtrl', ['ui-notification']).controller('SectorCtrl', SectorCtrl);
});
